import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store';
import { LoginType, TokenType } from 'type';
import api from 'api';

interface initialStateType {
   token: TokenType;
   isLoading: boolean;
   error: string;
   destination: string;
}

const initialState: initialStateType = {
   token: '' as TokenType,
   isLoading: false,
   error: '',
   destination: ''
};

export const getAuth = createAsyncThunk('auth/getAuth', async (args: LoginType, { rejectWithValue }) => {
   try {
      const { data } = await api.fetchAuth(args);
      console.log('data', data);
      return await data.auth_token;
   } catch (error) {
      console.log('error !');
      rejectWithValue(error);
   }
});

const authSlice = createSlice({
   name: 'auth',
   initialState,
   reducers: {
      logout(state) {
         return { ...state, token: '' };
      },
      updateDestination(state, { payload }: PayloadAction<string>) {
         return { ...state, destination: payload };
      }
   },
   extraReducers: {
      [`${getAuth.pending}`]: (state) => {
         state.isLoading = true;
      },
      [`${getAuth.fulfilled}`]: (state, action) => {
         state.isLoading = false;
         state.token = action.payload || '';
      },
      [`${getAuth.rejected}`]: (state, action) => {
         state.isLoading = true;
         state.error = action.payload;
      }
   }
});

export const getAuthSelector = (state: RootState) => state.auth;
export const { logout, updateDestination } = authSlice.actions;
export const tokenExists = (state: RootState) => state.auth.token.length > 1;
export const getIsLoading = (state: RootState) => state.auth.isLoading;
export default authSlice.reducer;
